/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU > TITLE
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	menutitle: {
		background: '#eee',
		padding: pxToEm(10),
		'& h2': {
			color: theme.color.supporting.dark.swatch,
			fontSize: pxToEm(16),
			fontWeight: 'normal',
			marginBottom: '0'
		}
	}
});